(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c4y-header-enhancement"]) return;
  try {
    
  const c4yMarkActiveNavigation = (header) => {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    const params = new URLSearchParams(window.location.search);
    const menuLinks = header.querySelectorAll('.header-main-menu-link');
    let activeLink = null;

    menuLinks.forEach((link) => {
      link.classList.remove('c4y-menu-active');
      link.removeAttribute('aria-current');
    });

    const summaryForChild = (href) => {
      const child = header.querySelector(`.sub-menu-content a[href="${href}"]`);
      return child?.closest('details')?.querySelector('summary') || null;
    };

    if (path === '/') {
      activeLink = header.querySelector('.header-main-menu-link[href="/"]');
    } else if (['/collections/uhren-1', '/collections/herren-uhren', '/collections/damen-uhren'].includes(path)) {
      activeLink = summaryForChild('/collections/herren-uhren') || summaryForChild('/collections/uhren-1');
    } else if (['/collections/schmuck', '/collections/herren-schmuck', '/collections/damen-schmuck'].includes(path)) {
      activeLink = summaryForChild('/collections/herren-schmuck') || summaryForChild('/collections/schmuck');
    } else if (path === '/collections/all' && params.get('sort_by') === 'created-descending') {
      activeLink = header.querySelector('.c4y-new-arrivals-menu .header-main-menu-link');
    } else if (path === '/collections/sale') {
      activeLink = header.querySelector('.header-main-menu-link[href="/collections/sale"]');
    }

    if (activeLink) {
      activeLink.classList.add('c4y-menu-active');
      if (activeLink.tagName === 'A') activeLink.setAttribute('aria-current', 'page');
    }
  };

  const c4yInstallNewArrivals = () => {
    const header = document.querySelector('#MainHeader');
    const template = document.querySelector('[data-c4y-new-template]');
    if (!header || !template) return;

    const contactLinks = header.querySelectorAll('a[href="/pages/contact"]');
    contactLinks.forEach((link) => {
      if (link.classList.contains('header-main-menu-link') && window.matchMedia('(min-width: 990px)').matches) {
        link.replaceWith(template.content.cloneNode(true));
      } else {
        link.textContent = template.dataset.newLabel;
        link.href = template.dataset.newUrl;
      }
    });

    c4yMarkActiveNavigation(header);
  };

  const c4yInstallInlineSearch = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const header = document.querySelector('#MainHeader');
    const template = document.querySelector('[data-c4y-search-template]');
    if (!header || !template) return;

    const trigger = header.querySelector('[data-open="drawer-search"]');
    if (!trigger || trigger.dataset.c4ySearchInstalled === 'true') return;

    const clone = template.content.cloneNode(true);
    trigger.replaceWith(clone);
  };

  const c4yGroupBrandsAlphabetically = () => {
    document.querySelectorAll('#MainHeader .sub-sub-menu').forEach((menu) => {
      if (menu.dataset.c4yGrouped === 'true') return;
      const items = Array.from(menu.children);
      let lastLetter = '';
      items.forEach((item) => {
        const label = item.textContent.trim();
        const letter = label.charAt(0).toUpperCase();
        if (letter && letter !== lastLetter) {
          const marker = document.createElement('div');
          marker.className = 'sub-sub-menu__letter';
          marker.textContent = letter;
          menu.insertBefore(marker, item);
          lastLetter = letter;
        }
      });
      menu.dataset.c4yGrouped = 'true';
    });
  };

  const c4yEnhanceSaleNav = (header) => {
    const saleLink = Array.from(header.querySelectorAll('.header-main-menu-link')).find(
      (el) => el.textContent.trim().replace(/\s+/g, ' ') === '% SALE'
    );
    if (!saleLink || saleLink.dataset.c4ySaleEnhanced === 'true') return;
    saleLink.classList.add('c4y-sale-link');
    saleLink.dataset.c4ySaleEnhanced = 'true';
  };

  const c4yInit = () => {
    c4yInstallNewArrivals();
    c4yInstallInlineSearch();
    c4yGroupBrandsAlphabetically();
    const header = document.querySelector('#MainHeader');
    if (header) c4yEnhanceSaleNav(header);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', c4yInit, { once: true });
  } else {
    c4yInit();
  }

  document.addEventListener('shopify:section:load', c4yInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c4y-home-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var AUTOPLAY_MS = 6000;

    document.querySelectorAll('[data-c4y-hero]').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-c4y-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-c4y-hero-dot]'));
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;

      var show = function (next) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      };

      var start = function () {
        if (reduceMotion) return;
        stop();
        timer = window.setInterval(function () {
          show(index + 1);
        }, AUTOPLAY_MS);
      };

      var stop = function () {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          start();
        });
      });

      // Touch devices fire "mouseenter" on tap but rarely a matching
      // "mouseleave" afterwards, so hover-based pause must stay
      // mouse-only or autoplay gets stuck paused after the first tap.
      if (canHover) {
        hero.addEventListener('mouseenter', stop);
        hero.addEventListener('mouseleave', start);
      }
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c4y-kinetic-stat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatNumber(n) {
      return Math.round(n)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-c4y-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var digits = el.querySelector('[data-c4y-count-digits]');
      if (!digits) return;

      if (reduceMotion || !target) {
        digits.textContent = formatNumber(target);
        return;
      }

      var animated = false;
      var duration = 1600;

      var run = function () {
        if (animated) return;
        animated = true;
        var start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          digits.textContent = formatNumber(target * eased);
          if (progress < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              run();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chrono-product-experience"] && !Shopify.designMode) return;
  try {
    
  const HEIDI_TIERS = [
    { ceiling: 50000, floor: 0, maxTerm: 12, downpaymentPct: 0 },
    { ceiling: 150000, floor: 50001, maxTerm: 24, downpaymentPct: 10 },
    { ceiling: 1000000, floor: 150001, maxTerm: 36, downpaymentPct: 25 },
  ];

  if (!customElements.get('chrono-product')) {
    customElements.define('chrono-product', class ChronoProduct extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mainImage = this.querySelector('.chrono-product__main-image');
        this.dialog = this.querySelector('[data-chrono-dialog]');
        this.dialogImage = this.querySelector('[data-chrono-dialog-image]');
        this.variantInput = this.querySelector('[data-chrono-variant-id]');
        this.price = this.querySelector('[data-chrono-price]');
        this.mobilePrice = this.querySelector('[data-chrono-mobile-price]');
        this.comparePrice = this.querySelector('[data-chrono-compare-price]');
        this.stock = this.querySelector('[data-chrono-stock]');
        this.availability = this.querySelector('[data-chrono-availability]');
        this.submit = this.querySelector('[data-chrono-submit]');
        this.mobileSubmit = this.querySelector('[data-chrono-mobile-submit]');
        this.finance = this.querySelector('[data-chrono-finance]');
        this.monthly = this.querySelector('[data-chrono-monthly]');
        this.mediaEl = this.querySelector('.chrono-product__main-media');
        this.purchaseColumn = this.querySelector('.chrono-product__purchase');
        this.term = 48;
        const variantsNode = this.querySelector('[data-chrono-variants]');
        this.variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];

        this.querySelectorAll('[data-chrono-thumb]').forEach((button) => {
          button.addEventListener('click', () => this.selectMedia(button));
        });

        this.querySelectorAll('[data-chrono-nav]').forEach((navButton) => {
          navButton.addEventListener('click', () => this.stepMedia(navButton.dataset.chronoNav));
        });

        const galleryEl = this.querySelector('[data-chrono-gallery]');
        if (galleryEl) {
          galleryEl.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.stepMedia('prev');
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.stepMedia('next');
            }
          });
        }

        this.querySelectorAll('[data-chrono-term]').forEach((button) => {
          button.addEventListener('click', () => {
            this.term = Number(button.dataset.chronoTerm);
            this.querySelectorAll('[data-chrono-term]').forEach((termButton) => {
              const active = termButton === button;
              termButton.classList.toggle('is-active', active);
              termButton.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            this.updateMonthly(this.currentVariant());
          });
        });

        this.querySelectorAll('[data-chrono-detail-tabs]').forEach((tabGroup) => {
          const tabs = Array.from(tabGroup.querySelectorAll('[data-chrono-detail-tab]'));
          const panels = Array.from(tabGroup.querySelectorAll('[data-chrono-detail-tab-panel]'));
          const activateTab = (activeTab, moveFocus = false) => {
            tabs.forEach((tab) => {
              const active = tab === activeTab;
              tab.setAttribute('aria-selected', active ? 'true' : 'false');
              tab.tabIndex = active ? 0 : -1;
              const panel = panels.find((candidate) => candidate.id === tab.getAttribute('aria-controls'));
              if (panel) panel.hidden = !active;
            });
            if (moveFocus) activeTab.focus();
          };

          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activateTab(tab));
            tab.addEventListener('keydown', (event) => {
              let nextIndex = index;
              if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
              if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
              if (event.key === 'Home') nextIndex = 0;
              if (event.key === 'End') nextIndex = tabs.length - 1;
              if (nextIndex === index) return;
              event.preventDefault();
              activateTab(tabs[nextIndex], true);
            });
          });
        });

        this.querySelectorAll('[data-chrono-option]').forEach((select) => {
          select.addEventListener('change', () => this.updateVariant());
        });

        const zoomButton = this.querySelector('[data-chrono-zoom]');
        const closeButton = this.querySelector('[data-chrono-dialog-close]');
        if (zoomButton && this.dialog) {
          zoomButton.addEventListener('click', () => {
            if (this.mainImage && this.dialogImage) this.dialogImage.src = this.mainImage.currentSrc || this.mainImage.src;
            this.dialog.showModal();
          });
        }
        if (closeButton && this.dialog) closeButton.addEventListener('click', () => this.dialog.close());
        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
        }

        const syncPurchaseHeight = () => {
          if (!this.purchaseColumn || !this.mediaEl) return;
          if (window.innerWidth < 900) {
            this.purchaseColumn.style.height = '';
            return;
          }
          const height = this.mediaEl.getBoundingClientRect().height;
          if (height > 0) this.purchaseColumn.style.height = height + 'px';
        };
        if (window.ResizeObserver && this.mediaEl) {
          new ResizeObserver(syncPurchaseHeight).observe(this.mediaEl);
        } else {
          window.addEventListener('resize', syncPurchaseHeight);
        }
        syncPurchaseHeight();
        requestAnimationFrame(syncPurchaseHeight);
        window.addEventListener('load', syncPurchaseHeight);
      }

      currentVariant() {
        const options = Array.from(this.querySelectorAll('[data-chrono-option]')).map((select) => select.value);
        if (!options.length) return this.variants[0];
        return this.variants.find((variant) => variant.options.every((option, index) => option === options[index]));
      }

      updateVariant() {
        const variant = this.currentVariant();
        if (!variant) {
          this.setAvailability(false, true);
          return;
        }
        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.price) this.price.textContent = variant.priceFormatted;
        if (this.mobilePrice) this.mobilePrice.textContent = variant.priceFormatted;
        if (this.comparePrice) {
          this.comparePrice.textContent = variant.compareAtPriceFormatted;
          this.comparePrice.hidden = !variant.compareAtPriceFormatted;
        }
        this.setAvailability(variant.available, false);
        this.updateMonthly(variant);
        if (this.finance) this.finance.hidden = variant.price > Number(this.finance.dataset.financeLimit);
        this.updateFinancePlan(variant);
        if (variant.featuredMediaId) {
          const mediaButton = this.querySelector(`[data-chrono-thumb][data-media-id="${variant.featuredMediaId}"]`);
          if (mediaButton) this.selectMedia(mediaButton);
        }
        if (window.history && this.dataset.productUrl) {
          window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
        }
      }

      setAvailability(available, unavailable) {
        const disabled = !available;
        if (this.submit) {
          this.submit.disabled = disabled;
          const label = this.submit.querySelector('span');
          if (label) label.textContent = available ? this.dataset.addToCart : this.dataset.soldOut;
        }
        if (this.mobileSubmit) this.mobileSubmit.disabled = disabled;
        if (this.stock) this.stock.textContent = unavailable || !available ? this.dataset.outOfStock : this.dataset.inStock;
        if (this.availability) this.availability.classList.toggle('is-unavailable', disabled);
      }

      updateMonthly(variant) {
        if (variant && this.monthly && variant.installments) this.monthly.textContent = variant.installments[String(this.term)];
      }

      heidiFormatMoney(cents) {
        var rounded = cents % 10 > 0 ? cents - (cents % 10) + 10 : cents;
        var value = (rounded / 100).toFixed(2).replace('.', ',');
        var parts = value.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        return 'CHF ' + parts.join(',');
      }

      updateFinancePlan(variant) {
        if (!this.finance) return;
        var termsGroup = this.finance.querySelector('[data-chrono-finance-terms]');
        if (!termsGroup) return;
        var tier = null;
        for (var i = 0; i < HEIDI_TIERS.length; i++) {
          var t = HEIDI_TIERS[i];
          if (variant.price >= t.floor && variant.price <= t.ceiling) tier = t;
        }
        if (!tier) return;
        var downpayment = Math.round(variant.price * tier.downpaymentPct / 100);
        var financed = variant.price - downpayment;
        var allowedTerms = (this.finance.dataset.heidiAllowedTerms || '')
          .split(',')
          .map((term) => Number(term))
          .filter((term) => Number.isFinite(term) && term > 0);
        var hasAllowedTerms = allowedTerms.length > 0;
        var buttons = Array.from(termsGroup.querySelectorAll('[data-heidi-term]'));
        var activeStillValid = false;
        buttons.forEach((btn) => {
          var term = Number(btn.dataset.heidiTerm);
          var visible = term <= tier.maxTerm;
          var allowed = !hasAllowedTerms || allowedTerms.includes(term);
          btn.hidden = !visible;
          btn.disabled = visible && !allowed;
          if (btn.disabled) {
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('aria-disabled');
          }
          if (visible) {
            var monthly = Math.round(financed / term);
            btn.dataset.heidiMonthly = this.heidiFormatMoney(monthly);
            if (allowed && btn.classList.contains('is-active')) activeStillValid = true;
          }
          if (!visible || !allowed) {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });
        var activeBtn = activeStillValid ? termsGroup.querySelector('.is-active') : null;
        if (!activeBtn && !this.finance.dataset.c4yChosenTerm) {
          buttons.forEach((btn) => { btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); });
          buttons.forEach((btn) => { if (!btn.hidden && !btn.disabled) activeBtn = btn; });
          if (activeBtn) { activeBtn.classList.add('is-active'); activeBtn.setAttribute('aria-pressed', 'true'); }
        }
        var summary = this.finance.querySelector(".heidi-plan-summary");
        if (summary) summary.hidden = !activeBtn || !hasAllowedTerms;
        var display = this.finance.querySelector('[data-heidi-monthly-display]');
        if (display && activeBtn) display.textContent = activeBtn.dataset.heidiMonthly;
        this.finance.dispatchEvent(new CustomEvent("c4y:finance-plan", { bubbles: true }));
        var downpaymentRow = this.finance.querySelector('[data-chrono-finance-downpayment]');
        if (downpaymentRow) {
          downpaymentRow.hidden = tier.downpaymentPct === 0;
          var pctEl = downpaymentRow.querySelector('[data-chrono-finance-downpayment-pct]');
          var amtEl = downpaymentRow.querySelector('[data-chrono-finance-downpayment-amount]');
          if (pctEl) pctEl.textContent = tier.downpaymentPct;
          if (amtEl) amtEl.textContent = this.heidiFormatMoney(downpayment);
        }
      }

      stepMedia(direction) {
        const thumbs = Array.from(this.querySelectorAll('[data-chrono-thumb]'));
        if (!thumbs.length) return;
        const activeIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
        const currentIndex = activeIndex === -1 ? 0 : activeIndex;
        const delta = direction === 'next' ? 1 : -1;
        const nextIndex = (currentIndex + delta + thumbs.length) % thumbs.length;
        this.selectMedia(thumbs[nextIndex]);
      }

      selectMedia(button) {
        if (!this.mainImage || !button.dataset.mediaSrc) return;
        const updateImage = () => {
          this.mainImage.removeAttribute('srcset');
          this.mainImage.src = button.dataset.mediaSrc;
          this.mainImage.classList.add('is-contain');
          this.querySelectorAll('[data-chrono-thumb]').forEach((thumbnail) => {
            const active = thumbnail === button;
            thumbnail.classList.toggle('is-active', active);
            thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(updateImage);
        } else {
          updateImage();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              requestAnimationFrame(() => {
                void this.offsetHeight;
                const contentHeight = this.scrollHeight;
                this.style.height = `${contentHeight}px`;

                const cardItems = this.querySelectorAll('.card');
                const gridySlider = this.querySelector('gridy-slider');
                if (gridySlider && cardItems.length > 0) {
                  gridySlider.style.setProperty('--items-count', cardItems.length);
                }

                setTimeout(() => {
                  this.style.height = 'auto';
                }, 2500);
              });
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
